var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotVisible(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 7.92947C4 5.72947 5.8 3.92947 8 3.92947C8.2 3.92947 8.3 3.92947 8.5 4.02947L9.4 3.12947C8.9 3.02947 8.5 2.92947 8 2.92947C3.6 2.92947 0 7.92947 0 7.92947C0 7.92947 0.8 9.12947 2.2 10.3295L4.1 8.42947C4 8.22947 4 8.12947 4 7.92947Z",
    fill: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.92947C12 10.1295 10.2 11.9295 7.99998 11.9295C7.79998 11.9295 7.69998 11.9295 7.49998 11.8295L6.59998 12.7295C7.09998 12.8295 7.49998 12.9295 7.99998 12.9295C12.4 12.9295 16 7.92947 16 7.92947C16 7.92947 15.2 6.72947 13.8 5.52947L11.9 7.42947C12 7.62947 12 7.72947 12 7.92947Z",
    fill: ""
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 8.4295L8.5 10.9295C9.8 10.6295 10.7 9.7295 11 8.4295Z",
    fill: ""
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.42947L7.5 4.92947C6.2 5.22947 5.3 6.12947 5 7.42947Z",
    fill: ""
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3637 1L0.999512 14.3642L1.6359 15.0006L15.0001 1.63639L14.3637 1Z",
    fill: ""
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotVisible);
export default __webpack_public_path__ + "static/media/not-visible.24721ecfc7ea2f02bd34ff1521f097c8.svg";
export { ForwardRef as ReactComponent };